<template>
    <b-card :header="$t('project.projectmembers')"
            header-tag="header"
            header-class="text-center"
            header-bg-variant="primary"
            class="mb-3">
        <ul class="list-unstyled mb-0">
            <b-media tag="li" v-for="collaborator in projectCollaborators" :key="collaborator.id">
                <avatar slot="aside"
                        :username="collaborator.displayName" 
                        :size="32"
                        :inline="true">
                </avatar>
                <b-row class="align-middle">
                    <b-col cols="10">
                        <span class="mt-0 mb-0">
                            <div class="mb-0 pb-0">   
                                <span class="mr-2">{{ collaborator.displayName }}</span>
                                <b-badge variant="secondary">
                                    {{(typeof collaborator.membership === "string") && ['OWNER', 'GUEST', 'MEMBER'].indexOf(collaborator.membership) >= 0 ?$t('project.settings.participants.roles.' + collaborator.membership.toLowerCase()) : collaborator.membership }}
                                </b-badge> 
                            </div>   
                            <div v-if="collaborator.duplicate">
                                <em><small>{{ collaborator.email }}</small></em>
                            </div>
                        </span>
                    </b-col>
                </b-row>
            </b-media>
        </ul>
    </b-card>
</template>

<script>
import Avatar from 'vue-avatar';

export default {
    components: {
        Avatar
    },

    computed: {
        projectCollaborators() {
            return this.$store.getters['projects/projectCollaborators'];
        }
    },

    created() {
        let projectId = this.$route.params.projectId;
        this.$store.dispatch('projects/loadCollaboratorsByProject', { projectId });
    }
}
</script>


<style lang="scss" scoped>
    .align-middle{
        padding: 0.25rem 0;
    }
    .list-unstyled{
        li{
            margin-bottom: 0.5rem;
        }
    }
</style>
